import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class Adresse extends AdornisEntity {
  static override _class = 'Adresse';

  @Field(() => String)
  streetAndNumber: Maybe<string>;

  @Field(() => String)
  district: Maybe<string>;

  @Field(() => String)
  zip: Maybe<string>;

  @Field(() => String)
  city: Maybe<string>;

  @Field(() => String, { default: v => v ?? 'DE' })
  country: Maybe<string>;

  @Field(() => String)
  auslandsPlz: Maybe<string>;

  @Field(() => String)
  attentionLine: Maybe<string>;
}
